'use client';
import { createContext, useContext } from 'react';
/**
 * Explicit lifecycle contract from the modal renderer to Aether Modal.
 *
 * Keeping this separate from `onClose` lets consumers wrap the injected close
 * handler without changing whether the manager waits for an exit animation.
 */
export const ManagedModalLifecycleContext = createContext(null);
export function useManagedModalLifecycleContext() {
    return useContext(ManagedModalLifecycleContext);
}
//# sourceMappingURL=ManagedModalLifecycleContext.js.map